export default __webpack_public_path__ + "static/media/tortas.52c96cad.jpeg";